<template>
 <div>
     <div class="row">
         <div class="col-md-12">
             <h3>Health Advocacy</h3>
             <p>
                 Healthcare benefits are provided under two potential avenues depending on your specific coverage. To access information about your benefits you can connect to information through the following link or by calling the numbers provided below.
             </p>
         </div>
     </div>
     <div class="row">
         <div class="col-md-6">
             <img src="/images/elderly_couple.png" class="embed-responsive"/>
         </div>
         <div class="col-md-6">
             <h5><a href="https://www.medicare.gov/" target="_blank">Medicare</a></h5>
             <p>
                 800-633-4227
             </p>
             <h5><a href="https://www.compassrosebenefits.com/CRBG/Plans/Compass_Rose_Health_Plan/CRBG/Health_Plan.aspx?hkey=836549f7-43f4-49eb-ad9f-7de00a8596aa" target="_blank">Compass Rose Benefit Group</a></h5>
             <p>
                 Local DC / MD / VA<br/>
                 571-449-2366
             </p>
             <p>
                 Toll-Free<br/>
                 866-368-7227<br/>
                 9am to 5 pm EST<br/>
             </p>
         </div>
     </div>
 </div>
</template>

<script>
    export default {
        props:[],
        mounted() {},

    }
</script>
